import {MetaTitleDesc} from "../meta";
import DocumentMeta from "react-document-meta";
import {Link} from "react-router-dom";

export default () => {
    const title = 'Сельский туризм';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>
                    <p>В последние годы в Беларуси начал активно развиваться сельский туризм. Появилась сеть сельских
                        мини-гостиниц. Уик-энд или отпуск в деревне – это отдых без забот на лоне природы. Белорусские
                        сельские усадьбы уникальны и неповторимы. Они не обязательно совершенны, но всегда колоритны,
                        отражают вкус и характер хозяина. Туристов в Брестской области принимают свыше 20 сельских
                        усадеб. Среди них есть старинные, современные, комфортные и спартанские. Есть усадьбы-коттеджи,
                        готовые удовлетворить самых взыскательных туристов. Есть усадьбы, созданные на базе деревенских
                        домов. Есть дачи, летние дома отдыха в деревнях. Все они расположены в очень живописных местах –
                        на берегу водоемов или в лесу. Каждая сельская усадьба предлагает свою программу отдыха: баня с
                        веником, рыбалка, сбор ягод, грибов, лекарственных трав, краеведческие походы, познавательные
                        экскурсии, сплав на байдарках или плотах и многое другое. Можно наслаждаться приготовленными
                        хозяйкой блюдами национальной кухни, бродить по окрестностям, участвовать в региональных
                        культурных мероприятиях и национальных праздниках, включаться в хозяйственные работы или
                        неспешно осваивать какое-нибудь старинное ремесло. Но главное – это ощущение полного покоя,
                        жизнь в мерном сельском ритме вдали от суматохи, возможность спокойно подумать о самом главном и
                        абсолютная свобода во время отдыха.</p>
                    <p><Link to='/reference-information-agriculturalmanors'>Сельские усадьбы Agricultural manors</Link></p>
                </div>
            </div>
        </>
    );
}